import { DB } from '~/plugins/firebase-plugin.js';
// var admin = require("firebase-admin");
// const firebase = require('@firebase/firestore');
// import firebase from '@firebase/app';

const types = {
	SET_PAST_MESSAGES: 'SET_PAST_MESSAGES',
	SET_CONTENT: 'SET_CONTENT',
	SET_TITLE: 'SET_TITLE',
};

export const state = () => ({
	messages: [],
});

export const getters = {
	messages(state) {
		return state.messages;
	}
};

export const mutations = {
	[types.SET_PAST_MESSAGES] (state, messages) {
		state.messages = messages;
	},
};

export const actions = {
    saveMessage({dispatch}, title, content) {
        dispatch('setMessage', title, content);
    },
    setContent({commit}, content) {
        commit('setContent', content);
    },
    setTitle({commit}, title) {
        commit('setTitle', title);
    },
    async fetchMessages({commit}, customer) {
		// Get all previous message titles and content.
        if (customer) {
			const customerRef = await DB.collection('customers').doc(customer).get();
			if (customerRef.exists) {
				const customerData = customerRef.data();
				console.log('Customer Data', customerData);
				commit(types.SET_PAST_MESSAGES, customerData.messages);
				// commit('setTitleHistory', customerData.messageTitles);
				// commit('setContentHistory', customerData.messageContent);
				// commit('setTitle', customerData.messageTitles.length > 0 ? customerData.messageTitles[0] : '');
				// commit('setContent', customerData.messageContent.length > 0 ? customerData.messageContent[0] : '');
			}
		}
	},
	// async saveMessage({commit}, messagePayload) {
	// 	// messagePayload needs to have properties: title & content, guid
	// 	const { title, content, guid } = messagePayload;

	// 	// First, need to make sure that this customer is part of the collection.
    //     const customersCollection = DB.collection('customers'); // Returns CollectionReference
    //     const customerDocument = customersCollection.doc(guid); // Returns DocumentReference

    //     const check = await customerDocument.get(); // Returns DocumentSnapshot
    //     if (!check.exists) {
	// 		console.log('Create new CUSTOMER');
    //         customersCollection.doc(guid).set({
    //             name: customerName
    //         });
	// 	}

	// 	try {
	// 		const updatedCustomer = await customerDocument.update({
	// 			pastMessages: firebase.firestore.FieldValue.arrayUnion({title, content})
	// 		});

	// 		console.log(updatedCustomer);
	// 	} catch (error) {
	// 		console.log('MESSAGE STORE - ERROR: ', error);
	// 	}
	// },
	//refreshUser({dispatch}, userPayload) {
		// await dispatch('clearError');

		// try {
		// 	// Now that we have the user, find the User in the Firestore database
		// 	// which is where we keep track of siperLOCK GUID, etc
		// 	let user = buildUserObject(userPayload);
		// 	const userData = await this.$axios.$get('/api/admin/user-data', {params: {uid: user.uid}});

		// 	// userData should contain properties from the Firestore database.
		// 	user = {...user, ...userData};
		// 	await dispatch('setUser', user);
		// 	await dispatch('setUid', user.uid);
		// } catch (error) {
		// 	console.log("Error getting user from database: ", error);
		// 	await dispatch('setError', 'Sorry, try logging in again. If unable to login, please e-mail engineering@conversasolutions.com for support.');
		// }
	//},
};

export const strict = false;
